import { useEffect, useMemo, useRef, useState } from "react";
import "./Testimonials.css";

export default function Testimonials() {
  const data = useMemo(
    () => [
      { n: "Client A", r: "“We got more leads in 2 weeks than the last 2 months.”" },
      { n: "Client B", r: "“Very professional designs and quick responses.”" },
      { n: "Client C", r: "“Ads are optimized well. Reporting is clear and simple.”" },
    ],
    []
  );

  const sectionRef = useRef(null);
  const [i, setI] = useState(0);
  const [dir, setDir] = useState(1); // 1 next, -1 prev
  const [animKey, setAnimKey] = useState(0);
  const hoverRef = useRef(false);

  const prev = () => {
    setDir(-1);
    setI((x) => (x - 1 + data.length) % data.length);
    setAnimKey((k) => k + 1);
  };

  const next = () => {
    setDir(1);
    setI((x) => (x + 1) % data.length);
    setAnimKey((k) => k + 1);
  };

  const ripple = (e) => {
    const btn = e.currentTarget;
    const r = btn.getBoundingClientRect();
    const x = ((e.clientX - r.left) / r.width) * 100;
    const y = ((e.clientY - r.top) / r.height) * 100;

    btn.style.setProperty("--px", `${x}%`);
    btn.style.setProperty("--py", `${y}%`);

    btn.classList.remove("is-rippling");
    // eslint-disable-next-line no-unused-expressions
    btn.offsetWidth;
    btn.classList.add("is-rippling");
  };

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const raf = requestAnimationFrame(() => el.classList.add("is-mounted"));

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("is-visible");
          io.disconnect();
        }
      },
      { threshold: 0.22 }
    );
    io.observe(el);

    return () => {
      cancelAnimationFrame(raf);
      io.disconnect();
    };
  }, []);

  // autoplay (paused on hover/focus)
  useEffect(() => {
    const mql = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (mql.matches) return;

    const t = setInterval(() => {
      if (hoverRef.current) return;
      next();
    }, 5200);

    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.length]);

  return (
    <section className="section testiSection" ref={sectionRef}>
      <div className="container">
        <span className="kicker reveal" style={{ "--d": "0ms" }}>
          Testimonials
        </span>
        <h2 className="h2 reveal" style={{ "--d": "90ms" }}>
          Clients love working with us
        </h2>
        <p className="p reveal" style={{ "--d": "180ms" }}>
          Replace names and reviews with your real clients.
        </p>

        <div
          className="testi card mt24 reveal"
          style={{ "--d": "270ms" }}
          onMouseEnter={() => (hoverRef.current = true)}
          onMouseLeave={() => (hoverRef.current = false)}
          onFocus={() => (hoverRef.current = true)}
          onBlur={() => (hoverRef.current = false)}
        >
          <div className="testi__bg" aria-hidden="true" />

          <div className="testi__quote" aria-hidden="true">
            ❝
          </div>

          {/* animated content swap */}
          <div
            className={`testi__swap ${dir === 1 ? "is-next" : "is-prev"}`}
            key={animKey}
          >
            <p className="testi__text">{data[i].r}</p>
            <div className="testi__name">— {data[i].n}</div>
          </div>

          <div className="testi__controls">
            <button className="btn" onPointerDown={ripple} onClick={prev}>
              Prev
            </button>
            <button className="btn btn-primary" onPointerDown={ripple} onClick={next}>
              Next
            </button>
          </div>

          {/* dots */}
          <div className="testi__dots" role="tablist" aria-label="Testimonials">
            {data.map((_, idx) => (
              <button
                key={idx}
                className={`testi__dot ${idx === i ? "is-active" : ""}`}
                onClick={() => {
                  setDir(idx > i ? 1 : -1);
                  setI(idx);
                  setAnimKey((k) => k + 1);
                }}
                aria-label={`Go to testimonial ${idx + 1}`}
                aria-pressed={idx === i}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
